import React, { useEffect, useRef, useState } from "react";
import {
  dashboard_invoice_approve,
  dashboard_invoice_green_tick,
  dashboard_invoice_order_date,
  dashboard_invoice_order_history,
  // dashboard_invoice_payment_done,
  // dashboard_logo_merchant,
  // calender_icon,
  // info_details_sample_car,
  merchant_dashboard_location_icon,
  pdf,
  manage_my_info_edit_logo,
} from "../../../assets/images";
import styled from "styled-components";
// import { MerchantInvoiceApprove } from "../../../types";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import axiosInstance from "../../../services/axios.instance";
import { useMutation } from "@tanstack/react-query";
import { API_URL } from "../../../services/apiConfig";
import { useForm } from "react-hook-form";
import ErrorModal from "../../ErrorModal";
// import SuccessModal from "../../SuccessModal";
import ConfirmationModal from "../../ConfirmationModal";
import { useLocation, useNavigate } from "react-router-dom";
import ImagePopupModal from "../ImagePopupModal";
import {
  // Modal,
  // ModalHeader,
  // ModalBody,
  // Button,
  Carousel,
} from "react-bootstrap";
import CustomInput from "../../CustomInput";
// import AuthRules from "../../../rules/AuthRules";
import { toast } from "react-toastify";
import CustomRadio from "../../customRadio";
// import DateTimeComponent from "../../DateTimeComponent";
// import TimePicker from "../../TimePicker/components/TimePicker";
import rules from "../../../rules";
import {
  // ChevronDown,
  // ChevronUp,
  // PencilSquare,
  Trash,
} from "react-bootstrap-icons";
import { OverlayTrigger, Popover } from "react-bootstrap";

const DeliveredorderDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const OrderId = new URLSearchParams(location.search).get("OrderId");
  const queryClient = useQueryClient();
  //const OrderId = state && state.OrderId;
  console.log("new", OrderId);
  const [utilizationDays, setUtilizationDays] = useState(0);
  const [initialDays, setInitialDays] = useState(0);
  const {
    data: invoiceDetails,
    // isLoading,
    // isError,
  } = useQuery({
    queryKey: ["invoiceDetails", OrderId],
    queryFn: async () => {
      const response = await axiosInstance.get(
        `${API_URL.ORDER_DETAILS}/${OrderId}/details`,
        {
          headers: {
            location: "0,0",
            language: "english",
          },
        }
      );
      return response.data;
    },
  });
  const { data: commentMessage } = useQuery({
    queryKey: ["commentMessage", OrderId],
    queryFn: async () => {
      const response = await axiosInstance.get(
        `${API_URL.GET_COMMENTS}/${OrderId}`
      );
      console.log("commentMessagestatuss", commentMessage);

      return response.data;
    },
  });
  // const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [showAcceptConfirmationModal, setShowAcceptConfirmationModal] =
    useState(false);
  const [showExtendConfirmationModal, setShowExtendConfirmationModal] =
    useState(false);
  const [acceptConfirmationMessage, setAcceptConfirmationMessage] =
    useState("");
  const [extendConfirmationMessage, setExtendConfirmationMessage] =
    useState("");
  const [
    showRecollectionRequestConfirmationModal,
    setShowRecollectionRequestConfirmationModal,
  ] = useState(false);
  const [
    recollectionRequestConfirmationMessage,
    setRecollectionRequestConfirmationMessage,
  ] = useState("");
  // const [isSuccess, setIsSuccess] = useState(false);
  // const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  //const [selectedSlot, setSelectedSlot] = useState("9-1");
  // const [selectedSlot, setSelectedSlot] = useState("");
  const [daysNumber, setDaysNumber] = useState("");
  const [plateNumberError, setPlateNumberError] = useState("");
  const [recollectedFuel, setRecollectedFuel] = useState("");
  const [recollectedMileage, setRecollectedMileage] = useState("");
  const [surcharge, setSurcharge] = useState("");
  const [salicCharge, setSalicCharge] = useState("");
  const [trafficCharge, setTrafficCharge] = useState("");
  const [agreementNumber, setAgreementNumber] = useState("");
  const [deliveryBoyName, setDeliveryBoyName] = useState("");
  const [deliveryBoyPhone, setDeliveryBoyPhone] = useState("");
  const [comments, setComments] = useState("");
  const [forceAmount, setForceAmount] = useState("");
  //345678909876545678
  const {
    control,
    formState: { isValid },
    // setValue,
    // getValues,
    // trigger,
  } = useForm({ mode: "onChange" });

  //------------------------------------------------------------------------

  // const handleSlotChange = (e: {
  //   target: { value: React.SetStateAction<string> };
  // }) => {
  //   setSelectedSlot(e.target.value);
  // };
  const [replacementUploadedImages, setReplacementUploadedImages] = useState<
    string[]
  >([]);
  const [replacementPreviousImages, setReplacementPreviousImages] = useState<
    string[]
  >([]);
  const [replacementVdrUploaded, setReplacementVdrUploaded] = useState(false);
  const replacementFileInputRef = useRef<HTMLInputElement>(null);
  const openReplacementFileInput = (event: any) => {
    event.preventDefault();
    replacementFileInputRef?.current?.click();
  };

  const handleNumberOfDaysChange = (value: React.SetStateAction<string>) => {
    setDaysNumber(value);
    setPlateNumberError("");
  };

  const handleDeliveryBoyNumberChange = (
    value: React.SetStateAction<string>
  ) => {
    setDeliveryBoyPhone(value);
  };

  const handleDeliveryBoyNameChange = (value: React.SetStateAction<string>) => {
    setDeliveryBoyName(value);
  };
  const handleFuelNumberChange = (value: React.SetStateAction<string>) => {
    if (value === recollectedFuel) {
      setRecollectedFuel("");
    } else {
      setRecollectedFuel(value);
    }
  };
  const handleMileageNumberChange = (value: React.SetStateAction<string>) => {
    setRecollectedMileage(value);
  };
  const handleSurchargeNumberChange = (value: React.SetStateAction<string>) => {
    setSurcharge(value);
  };
  const handleSalicNumberChange = (value: React.SetStateAction<string>) => {
    setSalicCharge(value);
  };
  const handleTrafficchargeNumberChange = (
    value: React.SetStateAction<string>
  ) => {
    setTrafficCharge(value);
  };
  const handleAgreementNumberChange = (value: React.SetStateAction<string>) => {
    setAgreementNumber(value);
  };

  const handleCommentsChange = (event: any) => {
    setComments(event.target.value);
  };

  const handleForceAmountChange = (value: React.SetStateAction<string>) => {
    setForceAmount(value);
  };

  const [dateTime, setDateTime] = useState("");
  const [minDateTime, setMinDateTime] = useState("");
  const [recollectionDateTime, setRecollectionDateTime] = useState("");
  const [enableRecollectionRequest, setEnableRecollectionChangeRequest] =
    useState(false);
  const [recollectionVdrImages, setRecollectionVdrImages] = useState<string[]>(
    []
  );
  const [recollectionVdrUploadedImages, setRecollectionVdrUploadedImages] =
    useState<string[]>([]);
  const recollectionVdrFileInputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    const now = new Date();
    const isoString = now.toISOString().substring(0, 16);
    setMinDateTime(isoString);
  }, []);

  // const handleDateTimeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   setDateTime(event.target.value);
  // };

  //===========================================
  useEffect(() => {
    if (invoiceDetails && invoiceDetails?.recollection_date) {
      setRecollectionDateTime(invoiceDetails?.recollection_date);
    }

    // Calculate Utilization Days from order_reassign_history_response
    if (invoiceDetails?.order_reassign_history_response) {
      const recollectionDateChangeItems =
        invoiceDetails.order_reassign_history_response.filter(
          (item: any) => item.request_type === "RECOLLECTION_DATE_CHANGE"
        );

      const totalUtilizationDays = recollectionDateChangeItems.reduce(
        (sum: number, item: any) => sum + (item.extended_rental_days || 0),
        0
      );

      // Get the last object from order_reassign_history_response for initialDays
      const lastHistoryItem =
        invoiceDetails.order_reassign_history_response[
        invoiceDetails.order_reassign_history_response.length - 1
        ];
      if (lastHistoryItem && lastHistoryItem.previous_rental_days) {
        setInitialDays(lastHistoryItem.previous_rental_days);
      }

      setUtilizationDays(totalUtilizationDays);
    }
  }, [invoiceDetails]);

  const handleDateTimeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newDateTime = event.target.value;
    console.log("NEW RECOLLECTION DATE", newDateTime);
    setDateTime(newDateTime);

    const recollectionDatePart = recollectionDateTime.slice(0, 10);
    const enteredDatePart = newDateTime.slice(0, 10);
    if (
      enteredDatePart !== recollectionDatePart &&
      enteredDatePart < recollectionDatePart
    ) {
      setRecollectionRequestConfirmationMessage(
        "Would you like to change the recollection date? Send request to Backoffice?"
      );
      setShowRecollectionRequestConfirmationModal(true);
      setEnableRecollectionChangeRequest(true);
    } else {
      setEnableRecollectionChangeRequest(false);
    }
  };

  const openRecollectionVdrFileInput = (event: any) => {
    event.preventDefault();
    recollectionVdrFileInputRef?.current?.click();
  };

  const handleRecollectionVdrUpload = async (files: FileList | null) => {
    if (files) {
      try {
        const promises = [];
        const uploadedFileURLs: any[] = [];
        for (const file of Array.from(files)) {
          const formData = new FormData();
          formData.append("product_image", file);

          const response = await axiosInstance.post(
            API_URL.PRODUCT_IMAGE_UPLOAD,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
          uploadedFileURLs.push(response.data);
          promises.push(response);
        }
        await Promise.all(promises);

        setRecollectionVdrImages((prevImages) => [
          ...prevImages,
          ...uploadedFileURLs,
        ]);
        setRecollectionVdrUploadedImages((prevUploadedImages) => [
          ...prevUploadedImages,
          ...uploadedFileURLs,
        ]);
        if (recollectionVdrFileInputRef.current) {
          recollectionVdrFileInputRef.current.value = "";
        }
        toast.success("VDR uploaded successfully!");
      } catch (error) {
        toast.error("Failed to upload VDR. Please try again.");
        console.error("Error uploading recollection VDR:", error);
      }
    }
  };

  const handleRecollectionVdrDeleteImage = (index: number) => {
    setRecollectionVdrUploadedImages((prevImages) =>
      prevImages.filter((_, i) => i !== index)
    );
    setRecollectionVdrImages((prevImages) =>
      prevImages.filter((_, i) => i !== index)
    );
  };

  // Function to update VDR documents after recollection request success
  const updateRecollectionVdrDocuments = async () => {
    if (recollectionVdrImages.length > 0) {
      try {
        console.log("Sending VDR update request with payload:", {
          order_number: OrderId || "",
          recollected_check_list_image_urls: recollectionVdrImages,
        });
        const response = await axiosInstance.put(
          API_URL.UPDATE_RENTAL_DOCUMENTS,
          {
            order_number: OrderId || "",
            recollected_check_list_image_urls: recollectionVdrImages,
          }
        );
        toast.success("VDR documents updated successfully!");

        // Clear VDR images after successful upload
        setRecollectionVdrImages([]);
        setRecollectionVdrUploadedImages([]);
        if (recollectionVdrFileInputRef.current) {
          recollectionVdrFileInputRef.current.value = "";
        }
      } catch (error) {
        console.error("Error updating recollection VDR documents:", error);
        toast.error("Failed to update VDR documents");
      }
    } else {
      console.log("No VDR images to update, skipping API call");
    }
  };

  // const handleOpenRecRequestConfirmationModal = (message: string) => {
  //   setRecollectionRequestConfirmationMessage(message);
  //   setShowRecollectionRequestConfirmationModal(true);
  // };

  const handleRecollectionRequest = useMutation({
    mutationFn: () =>
      axiosInstance.post(
        API_URL.ORDER_EDIT,
        {
          // merchant_id: invoiceDetails?.merchantId,
          order_number: OrderId,
          requested_recollection_date: dateTime + ":00",
          request_type: "RECOLLECTION_DATE_CHANGE",
        },
        {
          headers: {
            location: "o,o",
            language: "english",
          },
        }
      ),
    onSuccess: (successResponse) => {
      console.log("successResponse", successResponse);

      // If VDR images are uploaded, update the documents
      updateRecollectionVdrDocuments().then(() => {
        navigate("/merchant/deliveredorder");
      });
    },
    onError: (error: any) => {
      if (error?.response?.data?.message) {
        // Changed error?.data?.message to error?.response?.data?.message
        setErrorMessage(error.response.data.message);
        setShowErrorModal(true);
      }
    },
  });

  const forcePaymentMutation = useMutation({
    mutationFn: () =>
      axiosInstance.post(API_URL.CHARGE_OFF_SESSION, {
        order_number: OrderId,
        amount: Number(forceAmount),
        currency: "AED",
        type: "RECOVERY",
      }),
    onSuccess: () => {
      toast.success("Payment charged successfully!");
      setForceAmount("");
    },
    onError: (error: any) => {
      const msg = error?.response?.data?.message || "Failed to process payment";
      setErrorMessage(msg);
      setShowErrorModal(true);
    },
  });
  //======================================

  //--------------------------------------------------------------------------

  const handleOpenConfirmationModal = (message: string) => {
    setAcceptConfirmationMessage(message);
    setShowAcceptConfirmationModal(true);
  };

  const handleSubmit = () => {
    if (selectedOptions === "REPLACEMENT" && replacementVdrUploaded) {
      updateRentalDocumentsMutation.mutate({
        order_number: OrderId || "",
        additional_check_list_image_urls: replacementPreviousImages,
      });
    } else {
      handleOpenConfirmationModal("Recollected?");
    }
  };

  const handleApproval = useMutation({
    mutationFn: () => {
      // Get existing VDR images if no new images are uploaded
      const existingVdrImages =
        invoiceDetails?.products?.[0]?.recollectedCheckListImageUrls ||
        invoiceDetails?.products?.[0]?.recollected_check_list_image_urls ||
        invoiceDetails?.recollectedCheckListImageUrls ||
        invoiceDetails?.recollected_check_list_image_urls ||
        [];

      // Use newly uploaded images if available, otherwise use existing images
      const vdrImages =
        previousImages.length > 0 ? previousImages : existingVdrImages;
      return axiosInstance.put(
        `${API_URL.APPROVE_REJECT}/${OrderId}`,
        {
          order_status: "RECOLLECTED",
          check_list_image_urls: vdrImages,
          // plate_number: plateNumber,
          recollected_date: dateTime + ":00",
          recollection_fuel: recollectedFuel,
          recollection_millage: recollectedMileage,
          surcharge: surcharge || 0,
          traffic_fine: trafficCharge || 0,
          agreement_number: agreementNumber,
          salik_charge: salicCharge || 0,
          // delivery_start_time: "",
          // delivery_end_time: "",
          free_upgrade_by_customer: false,
          // free_upgrade_by_merchant: isChecked,
          merchant_comment: comments,
          delivery_boy_details: {
            firstName: deliveryBoyName,
            phoneNumber: deliveryBoyPhone,
          },
        },
        {
          headers: {
            location: "o,o",
            language: "english",
          },
        }
      );
    },
    onSuccess: (successResponse) => {
      console.log("successResponse", successResponse);

      navigate("/merchant/deliveredorder");
    },
    onError: (error: any) => {
      if (error?.data?.message) {
        setErrorMessage(error?.data?.message);
        setShowErrorModal(true);
      }
    },
  });

  const handleOpenExtendConfirmationModal = (message: string) => {
    setExtendConfirmationMessage(message);
    setShowExtendConfirmationModal(true);
  };

  const handleExtendDay = () => {
    handleOpenExtendConfirmationModal("Extend the number of rental days?");
  };
  // const handleAssign = () => {
  //   console.log("Assign button clicked");
  //   //navigate("/merchant/ApprovedDeliveryBoysList");
  // };

  const handleExtend = useMutation({
    mutationFn: () =>
      axiosInstance.post(
        API_URL.ORDER_EDIT,
        {
          merchant_id: invoiceDetails?.merchantId,
          order_number: OrderId,
          //rental_days: daysNumber,
          extended_rental_days: daysNumber,
          //comments: comments,
          order_comment: comments,
          delivery_location: invoiceDetails?.delivery_location,
          delivery_date: invoiceDetails?.delivery_date,
          request_type: "RENTAL_DAYS_EXTENSION",
        },
        {
          headers: {
            location: "o,o",
            language: "english",
          },
        }
      ),
    onSuccess: (successResponse) => {
      console.log("successResponse", successResponse);
      navigate("/merchant/deliveredorder");
    },
    onError: (error: any) => {
      if (error?.response?.data?.message) {
        // Changed error?.data?.message to error?.response?.data?.message
        setErrorMessage(error.response.data.message);
        setShowErrorModal(true);
      }
    },
  });

  const formatDate = (isoDate: any) => {
    if (!isoDate) return "N/A";

    const date = new Date(isoDate);
    // Check if date is invalid
    if (isNaN(date.getTime())) return "N/A";

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${day}-${month}-${year}`;
  };

  const [showImagePopupModal, setShowImagePopupModal] = useState(false);
  // const [selectedImage, setSelectedImage] = useState("");
  // const handleimagepopover = () => {
  //   setShowImagePopupModal(true);
  // };

  // const handleClose = () => {
  //   setLoadModal(false);
  // };

  // const [loadModal, setLoadModal] = useState(false);
  const [imageSource, setImageSource] = useState("");

  const fetchAndRenderDocs = (
    docsObject: Record<string, any> | undefined,
    prefix: string
  ) => {
    if (!docsObject) return;

    const matchedDocs = Object.keys(docsObject).filter((key) =>
      key.startsWith(prefix)
    );

    matchedDocs.forEach((docKey) => {
      const documentId = docsObject[docKey];
      if (documentId === undefined || documentId === null) {
        console.warn(`Document ID for ${docKey} is null or undefined`);
        return;
      }

      axiosInstance
        .get(`${API_URL.CUSTOMER_DOCUMENTS}/${documentId}`, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          if (!response || !response.data) {
            console.error(`Failed to fetch document for ${docKey}`);
            return;
          }

          const contentType = String(response.headers["content-type"] || "");
          const isPdf = contentType === "application/pdf";
          const isImage = contentType.startsWith("image/");

          if (isPdf) {
            const blob = new Blob([response.data], { type: "application/pdf" });
            const objectUrl = URL.createObjectURL(blob);

            const downloadLink = document.getElementById(
              `${docKey}DownloadLink`
            ) as HTMLAnchorElement;
            if (downloadLink) {
              downloadLink.href = objectUrl;
              downloadLink.style.display = "block";
              downloadLink.download = `${docKey}.pdf`;
            }

            const imageElement = document.getElementById(
              `${docKey}_IMAGE`
            ) as HTMLImageElement;
            if (imageElement) {
              imageElement.src = "/path/to/pdf-icon.png"; // replace with your static pdf icon
            }
          } else if (isImage) {
            const blob = new Blob([response.data], { type: contentType });
            const imageUrl = URL.createObjectURL(blob);

            const imageElement = document.getElementById(
              `${docKey}_IMAGE`
            ) as HTMLImageElement;
            if (imageElement) {
              imageElement.src = imageUrl;
              imageElement.onclick = () => {
                setImageSource(imageUrl);
                setShowImagePopupModal(true);
              };
            }

            const imageSizeKB = response.data.byteLength / 1000;
            console.log(`${docKey} Image Size:`, imageSizeKB, "KB");
          }
        })
        .catch((error) => {
          console.error(`Error fetching ${docKey}:`, error);
        });
    });
  };

  useEffect(() => {
    if (invoiceDetails?.customer_details) {
      const { customerDocs, customerAdditionalDocs } =
        invoiceDetails.customer_details;

      // 🔹 Main Docs
      fetchAndRenderDocs(customerDocs, "EMIRITIES");
      fetchAndRenderDocs(customerDocs, "LICENSE");
      fetchAndRenderDocs(customerDocs, "VisitVisa");

      // 🔹 Additional Docs
      fetchAndRenderDocs(customerAdditionalDocs, "EMIRITIES-ADD");
      fetchAndRenderDocs(customerAdditionalDocs, "LICENSE-ADD");
      fetchAndRenderDocs(customerAdditionalDocs, "EMIRITIES1-ADD");
      fetchAndRenderDocs(customerAdditionalDocs, "LICENSE1-ADD");
    }
  }, [invoiceDetails]);

  const [selectedOptions, setSelectedOptions] = useState<string>("");
  const handleRadioChange = (value: string) => {
    setSelectedOptions(value);
  };

  // const [dropOffDate, setDropOffDate] = useState<string>("");
  // const [pickupDate, setPickupDate] = useState<string>("");

  // const handleDropOffDateChange = (date: string) => {
  //   if (new Date(date) < new Date(pickupDate)) {
  //     setDropOffDate(pickupDate);
  //   } else {
  //     setDropOffDate(date);
  //   }
  // };
  // const [selectedDropTime, setSelectedDropTime] = useState("");

  // const handleDropOffTimeChange = (newTime: any) => {
  //   console.log("Selected time:", newTime);
  //   setSelectedDropTime(newTime);
  // };

  //------------------------------------------------------------------------------------------------------------
  // const [images, setImages] = useState<string[]>([]);
  const [uploadedImages, setUploadedImages] = useState<string[]>([]);
  const [previousImages, setpreviousImages] = useState<string[]>([]);
  // const [selectedFeatures, setSelectedFeatures] = useState<string[]>([]);

  const [vdrUploaded, setVdrUploaded] = useState(false);

  const fileInputRef = useRef<HTMLInputElement>(null);

  const openFileInput = (event: any) => {
    event.preventDefault();
    fileInputRef?.current?.click();
  };

  const handleUploadDeleteImage = (index: number) => {
    setUploadedImages((prevImages) => prevImages.filter((_, i) => i !== index));
    setpreviousImages((prevImages) => prevImages.filter((_, i) => i !== index));
  };
  //const [isSuccess, setIsSuccess] = useState(false);

  const handleImageUpload = async (files: FileList | null) => {
    if (files) {
      try {
        const promises = [];
        const uploadedFileURLs: any[] = [];
        for (const file of Array.from(files)) {
          const formData = new FormData();
          formData.append("product_image", file);

          const response = await axiosInstance.post(
            API_URL.PRODUCT_IMAGE_UPLOAD,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
          uploadedFileURLs.push(response.data);

          promises.push(response);
        }
        // Wait for all uploads to complete
        await Promise.all(promises);

        setpreviousImages((prevImages) => [...prevImages, ...uploadedFileURLs]);
        setUploadedImages((prevUploadedImages) => [
          ...prevUploadedImages,
          ...uploadedFileURLs,
        ]);
        //toast.success("Uploaded successfully!");
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
          setVdrUploaded(true);
        }
        toast.success("Uploaded successfully!");
      } catch (error) {
        toast.error("Failed. Please try again.");
        console.error("Error uploading images:", error);
      }
    }
  };

  // const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   if (e.target.files) {
  //     handleImageUpload(e.target.files);
  //   }
  // };

  const formatTime = (dateTimeString: string) => {
    const date = new Date(dateTimeString);
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hourCycle: "h23",
    });
  };

  const onClickVdrDocument = (imageUrl: string) => {
    setImageSource(imageUrl);
    setShowImagePopupModal(true);
  };
  //-------------------------------------------------------------------------------------------------------------------

  const refpopup = useRef(null);
  const handleReplacementImageUpload = async (files: FileList | null) => {
    if (files) {
      // Check if adding new files would exceed the 2-file limit
      if (replacementUploadedImages.length + files.length > 2) {
        toast.error("You can only upload up to 2 files");
        return;
      }

      try {
        const promises = [];
        const uploadedFileURLs: any[] = [];
        for (const file of Array.from(files)) {
          const formData = new FormData();
          formData.append("product_image", file);

          const response = await axiosInstance.post(
            API_URL.PRODUCT_IMAGE_UPLOAD,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
          uploadedFileURLs.push(response.data);
          promises.push(response);
        }

        await Promise.all(promises);

        setReplacementPreviousImages((prevImages) => [
          ...prevImages,
          ...uploadedFileURLs,
        ]);
        setReplacementUploadedImages((prevUploadedImages) => [
          ...prevUploadedImages,
          ...uploadedFileURLs,
        ]);

        if (replacementFileInputRef.current) {
          replacementFileInputRef.current.value = "";
          setReplacementVdrUploaded(true);
        }
        toast.success("Replacement images uploaded successfully!");
      } catch (error) {
        toast.error("Failed to upload replacement images. Please try again.");
        console.error("Error uploading replacement images:", error);
      }
    }
  };

  // Add this new handler for deleting replacement images
  const handleReplacementUploadDeleteImage = (index: number) => {
    setReplacementUploadedImages((prevImages) =>
      prevImages.filter((_, i) => i !== index)
    );
    setReplacementPreviousImages((prevImages) =>
      prevImages.filter((_, i) => i !== index)
    );
  };

  // Add the mutation for updating rental documents
  const updateRentalDocumentsMutation = useMutation({
    mutationFn: async (data: {
      order_number: string;
      additional_check_list_image_urls?: string[];
      recollected_check_list_image_urls?: string[];
    }) => {
      const response = await axiosInstance.put(
        API_URL.UPDATE_RENTAL_DOCUMENTS,
        data
      );
      return response.data;
    },
    onSuccess: () => {
      toast.success("Rental documents updated successfully!");
      // Clear all the uploaded images and reset the form
      setReplacementUploadedImages([]);
      setReplacementPreviousImages([]);
      setReplacementVdrUploaded(false);
      if (replacementFileInputRef.current) {
        replacementFileInputRef.current.value = "";
      }
      // Invalidate and refetch invoiceDetails
      queryClient.invalidateQueries({ queryKey: ["invoiceDetails", OrderId] });
    },
    onError: (error) => {
      setErrorMessage("Failed to update rental documents. Please try again.");
      setShowErrorModal(true);
      console.error("Error updating rental documents:", error);
    },
  });

  // Modify the isButtonDisabled function to include the replacement condition
  const isButtonDisabled = (): boolean => {
    if (!isValid) {
      return true;
    }
    if (selectedOptions === "EXTENDED") {
      return !daysNumber;
    }
    if (selectedOptions === "RECOLLECTION") {
      // Check if VDR is uploaded OR if existing VDR images are present
      const hasExistingVdr =
        invoiceDetails?.products?.[0]?.recollectedCheckListImageUrls?.length >
        0 ||
        invoiceDetails?.products?.[0]?.recollected_check_list_image_urls
          ?.length > 0 ||
        invoiceDetails?.recollectedCheckListImageUrls?.length > 0 ||
        invoiceDetails?.recollected_check_list_image_urls?.length > 0;

      const hasVdr = vdrUploaded || hasExistingVdr;

      return !dateTime || !hasVdr || !agreementNumber || enableRecollectionRequest;
    }
    if (selectedOptions === "REPLACEMENT") {
      return !replacementVdrUploaded;
    }
    if (selectedOptions === "FORCE_PAYMENT") {
      return !forceAmount;
    }
    return true;
  };

  const popoverHoverFocus = (
    <Popover id="popover-trigger-hover-focus" className="popover-custom-edit">
      <Popover.Body className="d-flex align-items-center">
        <span className="invoice-div-data text-light">
          Edited by Kirkos backoffice
        </span>
      </Popover.Body>
    </Popover>
  );
  const FuelBar = styled.div`
    display: flex;
    gap: 3px;
    align-items: center;
    padding: 8px;
    background: #000000;
    border-radius: 8px;
    width: fit-content;

    .fuel-segment {
      width: 12px;
      height: 25px;
      border-radius: 4px;
      background: #333333;
      cursor: pointer;
      transition: all 0.3s ease;
      position: relative;

      &:before {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 0;
        background: #f0b64f;
        border-radius: 4px;
        transition: height 0.3s ease;
      }

      &.active {
        background: #262626;

        &:before {
          height: 100%;
        }
      }

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 2px 4px rgba(240, 182, 79, 0.2);

        &:not(.active) {
          background: #404040;
        }
      }
    }

    .fuel-label {
      margin-left: 12px;
      font-size: 14px;
      color: #ffffff;
      min-width: 80px;
    }
  `;
  return (
    <div className="row">
      <div className="col-md-12 d-flex justify-content-center pt-5 pb-2">
        <p className="info-text mt-1" id="license"></p>
        {/* <div className="invoice-details-btn-div text-end">
          <button
            className="invoice-approve-btn"
            //disabled={isButtonDisabled}
            onClick={handleSubmit}
          >
            {" "}
            <img src={dashboard_invoice_approve} height={"14px"} alt="" />
            &nbsp;ACCEPT
          </button>

          <button className="invoice-approve-btn" onClick={handleExtendDay}>
            {" "}
            <span className="invoice-paid-failed-style"> &#10006;</span>
            &nbsp; ACCEPT
          </button>
        </div> */}
      </div>
      <div className="col-md-12 text-start div-bg-invoice-details">
        <div className="card card-bg-invoice-details" ref={refpopup}>
          <div className="card-body px-5">
            <div className="row  pt-4 pb-3">
              <div className="col-md-6">
                <table className="invoice-table-width">
                  <tr className="invoice-table-tr-first">
                    <td className="invoice-table-td">Purchase order #</td>
                    <td>Order Created At</td>
                  </tr>
                  <tr>
                    <td className="invoice-text-yellow">
                      {invoiceDetails?.orderId}
                    </td>
                    <td>{formatDate(invoiceDetails?.createdAt)}</td>
                  </tr>
                </table>
                <div className="col-md-12 pt-3">
                  {/* <div className="invoice-div-head">Invoice #</div>
                  <div className="invoice-text-yellow">DB 6001 2024 </div> */}
                  <div className="col-md-6 pt-2 pb-2">
                    {/* <img
                      src={invoiceDetails?.products[0]?.productImageUrls}
                      alt=""
                      className="img-fluid"
                    /> */}
                    <Carousel className="managemycarlist" controls={false}>
                      {invoiceDetails?.products?.[0]?.productImageUrls?.map(
                        (imageUrl: any, index: number) => (
                          <Carousel.Item
                            className="image-managemycar-height"
                            key={index}
                          >
                            <img
                              className="img-merchant-managecar"
                              src={imageUrl}
                              alt={`Product Image ${index + 1}`}
                            />
                          </Carousel.Item>
                        )
                      )}
                    </Carousel>
                  </div>
                  <div
                    className={`invoice-text-yellow d-flex align-items-center ${invoiceDetails?.latest_modified_field_flags?.productId
                      ? "text-danger"
                      : ""
                      }`}
                  >
                    {invoiceDetails?.products[0]?.productName}
                    {invoiceDetails?.modified_field_flags?.productId && (
                      <OverlayTrigger
                        container={refpopup}
                        trigger={["hover"]}
                        placement="top"
                        overlay={popoverHoverFocus}
                      >
                        <div className="ps-2">
                          <img
                            src={manage_my_info_edit_logo}
                            alt="Edit"
                            width="18"
                          />
                        </div>
                      </OverlayTrigger>
                    )}
                  </div>
                </div>
                <div
                  className={`col-md-12 invoice-div-head pt-3 d-flex align-items-center ${invoiceDetails?.latest_modified_field_flags
                    ?.delivery_location
                    ? "text-danger"
                    : ""
                    }`}
                >
                  Location
                  {invoiceDetails?.modified_field_flags?.delivery_location && (
                    <OverlayTrigger
                      container={refpopup}
                      trigger={["hover"]}
                      placement="top"
                      overlay={popoverHoverFocus}
                    >
                      <div className="ps-2">
                        <img
                          src={manage_my_info_edit_logo}
                          alt="Edit"
                          width="18"
                        />
                      </div>
                    </OverlayTrigger>
                  )}
                </div>

                <div className="col-md-12 invoice-div-data">
                  {" "}
                  {invoiceDetails?.delivery_location?.address}{" "}
                </div>
                {/* Only show Number of Days if not only utilizationDays exists */}

                <div
                  className={`col-md-12 invoice-div-head pt-3 d-flex align-items-center ${invoiceDetails?.latest_modified_field_flags?.rental_days
                    ? "text-danger"
                    : ""
                    }`}
                >
                  Number of Days
                  {invoiceDetails?.modified_field_flags?.rental_days && (
                    <OverlayTrigger
                      container={refpopup}
                      trigger={["hover"]}
                      placement="top"
                      overlay={popoverHoverFocus}
                    >
                      <div className="ps-2">
                        <img
                          src={manage_my_info_edit_logo}
                          alt="Edit"
                          width="18"
                        />
                      </div>
                    </OverlayTrigger>
                  )}
                </div>
                <div className="col-md-12 invoice-div-data">
                  {
                    // If both extended_rental_days and utilizationDays exist
                    invoiceDetails?.extended_rental_days > 0 &&
                      utilizationDays > 0
                      ? initialDays
                      : // If only extended_rental_days exists or no special conditions
                      invoiceDetails?.extended_rental_days > 0
                        ? invoiceDetails.rental_days -
                        invoiceDetails.extended_rental_days
                        : utilizationDays > 0
                          ? initialDays
                          : // Default case (no special conditions)
                          invoiceDetails?.rental_days
                  }
                </div>

                {/* Show Extended Rental Days if exists */}
                {invoiceDetails?.extended_rental_days > 0 && (
                  <>
                    <div className="col-md-12 invoice-div-head pt-3">
                      Extended Rental Days
                    </div>
                    <div className="col-md-12 invoice-div-data">
                      {invoiceDetails.extended_rental_days}
                    </div>
                  </>
                )}

                {/* Show Utilization Days if exists */}
                {utilizationDays > 0 && (
                  <>
                    <div className="col-md-12 invoice-div-head pt-3">
                      Reduced Days
                    </div>
                    <div className="col-md-12 invoice-div-data">
                      {utilizationDays}
                    </div>
                  </>
                )}
                {/* Show Utilization-Reduced Days if exists */}
                {utilizationDays > 0 && (
                  <>
                    <div className="col-md-12 invoice-div-head pt-3">
                      Utilization Days
                    </div>
                    <div className="col-md-12 invoice-div-data">
                      {invoiceDetails?.rental_days}
                    </div>
                  </>
                )}

                {/* Show Total Rental Days if either extended_rental_days or utilizationDays exists */}
                {(invoiceDetails?.extended_rental_days > 0 ||
                  utilizationDays > 0) && (
                    <>
                      <div className="col-md-12 invoice-div-head pt-3">
                        Total Rental Days
                      </div>
                      <div className="col-md-12 invoice-div-data">
                        {invoiceDetails?.rental_days}
                      </div>
                    </>
                  )}
                <div className="col-md-12 invoice-div-head pt-3">
                  Payment Method
                </div>
                <div className="col-md-12 invoice-div-data">
                  {invoiceDetails?.payment_method}
                </div>
                <div className="col-md-12 invoice-div-head pt-3">
                  License Number
                </div>
                <div className="col-md-12 invoice-div-data">
                  {invoiceDetails?.customer_details?.drivingLicenseNumber}
                </div>
                <div className="col-md-12 invoice-div-head pt-3">
                  License Expiry Date
                </div>
                <div className="col-md-12 invoice-div-data">
                  {formatDate(
                    invoiceDetails?.customer_details?.licenceExpiryDate
                  )}
                </div>
              </div>
              <div className="col-md-6 border-start-invoice-details">
                <div className="col-md-12 invoice-div-head">Customer Name</div>
                <div className="col-md-12 invoice-div-data">
                  {invoiceDetails?.customer_details?.firstname}&nbsp;
                  {invoiceDetails?.customer_details?.lastname}
                </div>
                <div className="col-md-12 invoice-div-head pt-3">
                  Customer email
                </div>
                <div className="col-md-12 invoice-div-data">
                  {invoiceDetails?.customer_details?.email}
                </div>
                <div className="col-md-12 invoice-div-head pt-3">
                  Customer Phone Number
                </div>
                <div className="col-md-12 invoice-div-data">
                  {invoiceDetails?.customer_phone_number}
                </div>
                <div
                  className={`col-md-12 invoice-div-head pt-3 d-flex align-items-center ${invoiceDetails?.latest_modified_field_flags
                    ?.delivery_start_time
                    ? "text-danger"
                    : ""
                    }`}
                >
                  Slot Time
                  {invoiceDetails?.modified_field_flags
                    ?.delivery_start_time && (
                      <OverlayTrigger
                        container={refpopup}
                        trigger={["hover"]}
                        placement="top"
                        overlay={popoverHoverFocus}
                      >
                        <div className="ps-2">
                          <img
                            src={manage_my_info_edit_logo}
                            alt="Edit"
                            width="18"
                          />
                        </div>
                      </OverlayTrigger>
                    )}
                </div>
                <div className="col-md-12 invoice-div-data">
                  {formatTime(invoiceDetails?.delivery_start_time)} to{" "}
                  {formatTime(invoiceDetails?.delivery_end_time)}
                </div>
                <div className="col-md-12 invoice-div-head pt-3">
                  Delivery Time
                </div>
                <div className="col-md-12 invoice-div-data">
                  {invoiceDetails?.delivery_date?.split("T")[1]?.substring(0, 5)}
                </div>
                {invoiceDetails?.delivered_by === "CUSTOMER" && (
                  <>
                    <div
                      className={`col-md-12 invoice-div-head pt-3 d-flex align-items-center ${invoiceDetails?.latest_modified_field_flags
                        ?.delivered_by
                        ? "text-danger"
                        : ""
                        }`}
                    >
                      Pickup By
                      {invoiceDetails?.modified_field_flags?.delivered_by && (
                        <OverlayTrigger
                          container={refpopup}
                          trigger={["hover"]}
                          placement="top"
                          overlay={popoverHoverFocus}
                        >
                          <div className="ps-2">
                            <img
                              src={manage_my_info_edit_logo}
                              alt="Edit"
                              width="18"
                            />
                          </div>
                        </OverlayTrigger>
                      )}
                    </div>
                    <div className="col-md-12 invoice-div-data">
                      {invoiceDetails?.delivered_by}
                    </div>
                  </>
                )}
                {invoiceDetails?.delivered_by === "KIRKOS_EXECUTIVE" && (
                  <>
                    <div
                      className={`col-md-12 invoice-div-head pt-3 d-flex align-items-center ${invoiceDetails?.latest_modified_field_flags
                        ?.delivered_by
                        ? "text-danger"
                        : ""
                        }`}
                    >
                      Delivery By
                      {invoiceDetails?.modified_field_flags?.delivered_by && (
                        <OverlayTrigger
                          container={refpopup}
                          trigger={["hover"]}
                          placement="top"
                          overlay={popoverHoverFocus}
                        >
                          <div className="ps-2">
                            <img
                              src={manage_my_info_edit_logo}
                              alt="Edit"
                              width="18"
                            />
                          </div>
                        </OverlayTrigger>
                      )}
                    </div>
                    <div className="col-md-12 invoice-div-data">
                      {invoiceDetails?.delivered_by}
                    </div>
                  </>
                )}
                {invoiceDetails && invoiceDetails?.insurance_order === true && (
                  <>
                    <div className="col-md-12 invoice-div-head pt-3">
                      Insurance Claim
                    </div>
                    <div className="col-md-12 invoice-div-data">
                      {invoiceDetails?.insurance_claim}
                    </div>
                    <div className="col-md-12 invoice-div-head pt-3">
                      Service Number
                    </div>
                    <div className="col-md-12 invoice-div-data">
                      {invoiceDetails?.erp_service_number}
                    </div>
                  </>
                )}

                <div className="col-md-12 invoice-div-head pt-3">
                  Free Upgrade By Merchant
                </div>
                {invoiceDetails?.free_upgrade_by_customer === true ||
                  invoiceDetails?.free_upgrade_by_merchant === true ? (
                  <div className="col-md-12 invoice-div-data">Yes</div>
                ) : (
                  <div className="col-md-12 invoice-div-data">No</div>
                )}

                <div
                  className={`col-md-12 invoice-div-head d-flex align-items-center ${invoiceDetails?.latest_modified_field_flags?.babySeat ||
                    invoiceDetails?.latest_modified_field_flags
                      ?.additionalDriver ||
                    invoiceDetails?.latest_modified_field_flags?.cdw_amount ||
                    invoiceDetails?.latest_modified_field_flags
                      ?.windShieldProtection ||
                    invoiceDetails?.latest_modified_field_flags?.scdwAmount ||
                    invoiceDetails?.latest_modified_field_flags
                      ?.paiInsuranceAmount
                    ? "text-danger"
                    : ""
                    }`}
                >
                  Additional Options
                  {(invoiceDetails?.modified_field_flags?.babySeat ||
                    invoiceDetails?.modified_field_flags?.additionalDriver ||
                    invoiceDetails?.modified_field_flags?.cdw_amount ||
                    invoiceDetails?.modified_field_flags
                      ?.windShieldProtection ||
                    invoiceDetails?.modified_field_flags?.scdwAmount ||
                    invoiceDetails?.modified_field_flags
                      ?.paiInsuranceAmount) && (
                      <OverlayTrigger
                        container={refpopup}
                        trigger={["hover"]}
                        placement="top"
                        overlay={popoverHoverFocus}
                      >
                        <div className="ps-2">
                          <img
                            src={manage_my_info_edit_logo}
                            alt="Edit"
                            width="18"
                          />
                        </div>
                      </OverlayTrigger>
                    )}
                </div>
                <div className="col-md-12 invoice-div-data">
                  <ul style={{ paddingLeft: '20px', marginBottom: '0', lineHeight: '1.8' }}>
                    {invoiceDetails?.products[0]?.babySeatAmount !== 0 &&
                      invoiceDetails?.products[0]?.babySeatAmount !== null && (
                        <li style={{ marginBottom: '8px' }}>Baby Seat</li>
                      )}{" "}
                    {invoiceDetails?.products[0]?.paiInsuranceAmount !== 0 &&
                      invoiceDetails?.products[0]?.paiInsuranceAmount !==
                      null && <li style={{ marginBottom: '8px' }}>PAI Insurance</li>}{" "}
                    {invoiceDetails?.products[0]?.windShieldProtection !== 0 &&
                      invoiceDetails?.products[0]?.windShieldProtection !==
                      null && <li style={{ marginBottom: '8px' }}>WindShield Protection</li>}{" "}
                    {invoiceDetails?.products[0]?.additionalDriverAmount !== 0 &&
                      invoiceDetails?.products[0]?.additionalDriverAmount !==
                      null && <li style={{ marginBottom: '8px' }}>Additional Driver</li>}{" "}
                    {invoiceDetails?.products[0]?.scdwAmount !== 0 &&
                      invoiceDetails?.products[0]?.scdwAmount !== null && (
                        <li style={{ marginBottom: '8px' }}>SCDW Insurance</li>
                      )}{" "}
                    {invoiceDetails?.products[0]?.cdwAmount !== 0 &&
                      invoiceDetails?.products[0]?.cdwAmount !== null && (
                        <li style={{ marginBottom: '8px' }}>CDW Insurance</li>
                      )}{" "}
                  </ul>
                </div>
              </div>
              {/* {invoiceDetails && invoiceDetails?.insurance_order === true && (
                <div className="col-md-12 pt-3">
                  <div className="row bg-delivery-details pb-3">
                    <div className="col-md-12 invoice-div-head pt-3 fs-6 invoice-text-yellow">
                      Insurance Details
                    </div>

                    <div className="col-md-6">
                      <div className="invoice-div-head pt-3">
                        Insurance company
                      </div>
                      <div className="invoice-div-data">
                        {invoiceDetails?.insurance_company}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="invoice-div-head pt-3">
                        Insurance Policy
                      </div>
                      <div className="invoice-div-data">
                        {invoiceDetails?.insurance_policy}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="invoice-div-head pt-3">
                        Insurance Claim
                      </div>
                      <div className="invoice-div-data">
                        {invoiceDetails?.insurance_claim}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="invoice-div-head pt-3">
                        Insurance Expiry Date
                      </div>
                      <div className="invoice-div-data">
                        {formatDate(invoiceDetails?.insurance_expiry_date)}
                      </div>
                    </div>

                    {invoiceDetails?.plate_number && (
                      <>
                        <div className="col-md-6">
                          <div className="invoice-div-head pt-3">
                            Customer Plate Number
                          </div>
                          <div className="invoice-div-data">
                            {invoiceDetails?.plate_number}
                          </div>
                        </div>
                      </>
                    )}
                    {invoiceDetails?.chassis_number && (
                      <>
                        <div className="col-md-6">
                          <div className=" invoice-div-head pt-3">
                            Customer Chassis Number
                          </div>
                          <div className=" invoice-div-data">
                            {invoiceDetails?.chassis_number}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              )} */}
              <div className="col-12 pt-3">
                <div className="row bg-delivery-details pb-3">
                  <div className="col-md-12 invoice-div-head pt-3 fs-6  invoice-text-yellow">
                    Delivery Details
                  </div>
                  <div className="col-md-6">
                    <div className="col-md-12 invoice-div-head pt-3">
                      Plate Number
                    </div>
                    <div className="col-md-12 invoice-div-data">
                      {invoiceDetails?.products[0].plateNumber}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="col-md-12 invoice-div-head pt-3">
                      Delivery Executive Name
                    </div>
                    <div className="col-md-12 invoice-div-data">
                      {invoiceDetails?.delivery_boy_details?.firstName}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="col-md-12 invoice-div-head pt-3">
                      Delivery Executive Phone No
                    </div>
                    <div className="col-md-12 invoice-div-data">
                      +971 {invoiceDetails?.delivery_boy_details?.phoneNumber}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="col-md-12 invoice-div-head pt-3">
                      Delivery Date and Time
                    </div>
                    <div className="col-md-12 invoice-div-data">
                      {new Date(
                        invoiceDetails?.delivery_date
                      ).toLocaleDateString("en-GB")}{" "}
                      at{" "}
                      {new Date(
                        invoiceDetails?.delivery_date
                      ).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                        hourCycle: "h23",
                      })}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 pt-3">
                <div className="row bg-delivery-details pb-3">
                  <div className="col-md-12 invoice-div-head pt-3 fs-6 invoice-text-yellow">
                    Comments
                  </div>
                  <div className="col-md-6">
                    {commentMessage && commentMessage.length > 0 && (
                      <div className="invoice-div-head pt-3 ">
                        BackOffice Comments
                        {commentMessage
                          .filter(
                            (item: any) =>
                              item?.orderStatus === "ORDER_ACCEPT" ||
                              item?.createdBy === "ROLE_MAKER"
                          )
                          .map((item: any, index: number) => (
                            <li
                              key={index}
                              className="pt-2 col-md-12 invoice-div-data"
                            >
                              {item?.message}
                            </li>
                          ))}
                      </div>
                    )}
                    {/* <div className="invoice-div-data style-word-brk">
                      {invoiceDetails?.order_comment}
                    </div> */}
                  </div>
                  <div className="col-md-6">
                    {commentMessage && commentMessage.length > 0 && (
                      <div className="invoice-div-head pt-3 ">
                        Merchant Comments
                        {commentMessage
                          .filter(
                            (item: any) => item?.createdBy === "ROLE_MERCHANT"
                          )
                          .map((item: any, index: number) => (
                            <li
                              key={index}
                              className="pt-2 col-md-12 invoice-div-data"
                            >
                              {item?.message}
                            </li>
                          ))}
                      </div>
                    )}
                    {/* <div className="invoice-div-data style-word-brk">
                      {invoiceDetails?.order_comment}
                    </div> */}
                  </div>
                  {/* <div className="invoice-div-data style-word-brk">
                      {invoiceDetails?.merchant_comment}
                    </div> */}
                </div>
              </div>
              <div className="col-md-6 pt-5 align-content-center">
                <div className="row mt-4">
                  {(() => {
                    const docTypes = [
                      {
                        keyPrefix: "EMIRITIES",
                        label: "EMIRATES",
                        object: invoiceDetails?.customer_details?.customerDocs,
                      },
                      {
                        keyPrefix: "LICENSE",
                        label: "LICENSE",
                        object: invoiceDetails?.customer_details?.customerDocs,
                      },
                      {
                        keyPrefix: "VisitVisa",
                        label: "VISA",
                        object: invoiceDetails?.customer_details?.customerDocs,
                      },
                      {
                        keyPrefix: "Passport",
                        label: "Passport",
                        object: invoiceDetails?.customer_details?.customerDocs,
                      },
                      {
                        keyPrefix: "EMIRITIES-ADD",
                        label: "EMIRATES-ADD",
                        object:
                          invoiceDetails?.customer_details
                            ?.customerAdditionalDocs,
                      },
                      {
                        keyPrefix: "LICENSE-ADD",
                        label: "LICENSE-ADD",
                        object:
                          invoiceDetails?.customer_details
                            ?.customerAdditionalDocs,
                      },
                      {
                        keyPrefix: "EMIRITIES1-ADD",
                        label: "EMIRATES-ADD",
                        object:
                          invoiceDetails?.customer_details
                            ?.customerAdditionalDocs,
                      },
                      {
                        keyPrefix: "LICENSE1-ADD",
                        label: "LICENSE1-ADD",
                        object:
                          invoiceDetails?.customer_details
                            ?.customerAdditionalDocs,
                      },
                    ];

                    return docTypes.map(({ keyPrefix, label, object }) => {
                      if (!object) return null;

                      return Object.keys(object)
                        .filter((key) => key.startsWith(keyPrefix))
                        .map((key) => (
                          <div
                            key={key}
                            id={`${key}_container`}
                            className="col-md-6 mb-2"
                          >
                            <p>{label}: </p>

                            <img
                              id={`${key}_IMAGE`}
                              src={object[key]}
                              style={{ width: 75, height: 75 }}
                              alt={`${key} document`}
                            />

                            <a
                              className="download-img"
                              id={`${key}DownloadLink`}
                              href={object[key]}
                              title={`Download ${key} PDF`}
                              style={{ display: "none" }}
                            >
                              Download {key} PDF
                            </a>
                          </div>
                        ));
                    });
                  })()}
                </div>
                <div className="col-md-12 radio_button_text-order pt-3">
                  Documents(VDR & RentalAgreement)
                </div>
                <div className="row pt-3">
                  {invoiceDetails?.products[0]?.checkListImageUrls?.map(
                    (url: string | undefined, index: number) => (
                      <div className="col-6" key={index as number}>
                        {url?.endsWith(".pdf") ? (
                          <a
                            href={url}
                            download={`Checklist ${(index as number) + 1}.pdf`}
                            style={{ display: "block", margin: "10px 0" }}
                          >
                            <img
                              src={pdf}
                              alt="PDF"
                              style={{ width: 75, height: 75 }}
                            />
                            <div>Download Document {(index as number) + 1}</div>
                          </a>
                        ) : (
                          <div>
                            <img
                              src={url}
                              onClick={() => onClickVdrDocument(url!)}
                              alt={`Checklist ${(index as number) + 1}`}
                              style={{ width: 75, height: 75 }}
                            />
                            <a
                              href={url}
                              download={`Checklist ${(index as number) + 1
                                }${url?.substring(url.lastIndexOf("."))}`}
                              style={{
                                display: "block",
                                marginTop: "5px",
                                fontSize: "14px",
                              }}
                            >
                              Download Image
                            </a>
                          </div>
                        )}
                      </div>
                    )
                  )}
                  {invoiceDetails?.products[0]?.additionalCheckListImageUrls?.map(
                    (url: string | undefined, index: number) => (
                      <div className="col-6" key={index as number}>
                        {url?.endsWith(".pdf") ? (
                          <a
                            href={url}
                            download={`Checklist ${(index as number) + 1}.pdf`}
                            style={{ display: "block", margin: "10px 0" }}
                          >
                            <img
                              src={pdf}
                              alt="PDF"
                              style={{ width: 75, height: 75 }}
                            />
                            <div>Download Document {(index as number) + 1}</div>
                          </a>
                        ) : (
                          <div>
                            <img
                              src={url}
                              onClick={() => onClickVdrDocument(url!)}
                              alt={`Checklist ${(index as number) + 1}`}
                              style={{ width: 75, height: 75 }}
                            />
                            <a
                              href={url}
                              download={`Checklist ${(index as number) + 1
                                }${url?.substring(url.lastIndexOf("."))}`}
                              style={{
                                display: "block",
                                marginTop: "5px",
                                fontSize: "14px",
                              }}
                            >
                              Download Image
                            </a>
                          </div>
                        )}
                      </div>
                    )
                  )}

                  {invoiceDetails?.products[0]?.productLayoutImageUrls?.map(
                    (url: string | undefined, index: number) => (
                      <div className="col-6" key={index as number}>
                        {url?.endsWith(".pdf") ? (
                          <a
                            href={url}
                            download={`Checklist ${(index as number) + 1}.pdf`}
                            style={{ display: "block", margin: "10px 0" }}
                          >
                            Download Document {(index as number) + 1}
                          </a>
                        ) : (
                          <img
                            src={url}
                            onClick={() => onClickVdrDocument(url!)}
                            alt={`Checklist ${(index as number) + 1}`}
                            style={{ width: 75, height: 75 }}
                          />
                        )}
                      </div>
                    )
                  )}

                  {invoiceDetails && invoiceDetails.customer_signature ? (
                    <div className="col-6">
                      {invoiceDetails.customer_signature.endsWith(".pdf") ? (
                        <a
                          href={invoiceDetails.customer_signature}
                          download="Checklist.pdf"
                          style={{ display: "block", margin: "10px 0" }}
                        >
                          Download Document
                        </a>
                      ) : (
                        <img
                          src={invoiceDetails.customer_signature}
                          onClick={() =>
                            onClickVdrDocument(
                              invoiceDetails.customer_signature
                            )
                          }
                          alt="Customer Signature"
                          style={{
                            width: 75,
                            height: 75,
                            cursor: "pointer",
                            backgroundColor: "white",
                          }}
                        />
                      )}
                    </div>
                  ) : (
                    <div>No customer signature available</div>
                  )}
                </div>
              </div>
              <div className="col-md-6 pt-5">
                <div className="card invoice-card-inner">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-1  text-center">
                        <img
                          src={dashboard_invoice_order_history}
                          height={"16px"}
                          alt=""
                        />
                      </div>
                      <div className="col invoice-text-yellow">
                        Order History
                      </div>
                    </div>
                    <div className="col-md-11 pt-3">
                      <div className="d-flex ">
                        <div className="col-1  text-center">
                          <img
                            src={dashboard_invoice_order_date}
                            height={"18px"}
                            alt=""
                          />
                        </div>
                        <div className="col">
                          <div className="invoice-div-head">
                            Purchase order Date
                          </div>
                          <div className="invoice-inner-card-text">
                            {formatDate(invoiceDetails?.createdAt)}{" "}
                          </div>
                        </div>
                      </div>
                      <div className="d-flex ps-2">
                        <div className="col-1 text-center hor_line"></div>
                      </div>
                      <div className="d-flex pt-2">
                        <div className="col-1  text-center">
                          <img
                            src={dashboard_invoice_green_tick}
                            height={"18px"}
                            alt=""
                          />
                        </div>
                        <div className="col">
                          <div className=" invoice-div-head">Status</div>
                          <div className=" invoice-text-green">
                            {invoiceDetails?.orderStatus}
                          </div>
                        </div>
                      </div>
                      <div className="d-flex ps-2">
                        <div className="col-1 text-center hor_line"></div>
                      </div>
                      <div className="d-flex pt-2">
                        <div className="col-1  text-center">
                          <img
                            src={merchant_dashboard_location_icon}
                            height={"18px"}
                            alt=""
                          />
                        </div>
                        <div className="col">
                          <div
                            className={`col-md-12 invoice-div-head d-flex align-items-center ${invoiceDetails?.latest_modified_field_flags
                              ?.delivery_location ||
                              invoiceDetails?.latest_modified_field_flags
                                ?.delivery_date
                              ? "text-danger"
                              : ""
                              }`}
                          >
                            Delivery Date & Location
                            {(invoiceDetails?.modified_field_flags
                              ?.delivery_location ||
                              invoiceDetails?.modified_field_flags
                                ?.delivery_date) && (
                                <OverlayTrigger
                                  container={refpopup}
                                  trigger={["hover"]}
                                  placement="top"
                                  overlay={popoverHoverFocus}
                                >
                                  <div className="ps-2">
                                    <img
                                      src={manage_my_info_edit_logo}
                                      alt="Edit"
                                      width="18"
                                    />
                                  </div>
                                </OverlayTrigger>
                              )}
                          </div>
                          <div className="invoice-inner-card-text">
                            {formatDate(invoiceDetails?.delivery_date)} |
                            {invoiceDetails?.delivery_location?.address}
                          </div>
                        </div>
                      </div>

                      <div className="col-md-11 pt-3">
                        {invoiceDetails?.order_reassign_history_response?.some(
                          (history: any) => history?.delivery_date
                        ) &&
                          invoiceDetails?.order_reassign_history_response?.some(
                            (history: any) =>
                              history?.previous_delivery_date !==
                              history?.delivery_date
                          ) && (
                            <>
                              <div className="d-flex">
                                <div className="col-1 text-center">
                                  <img
                                    src={dashboard_invoice_order_date}
                                    height={"18px"}
                                    alt=""
                                  />
                                </div>
                                <div className="col">
                                  <div className="invoice-div-head">
                                    Initial Delivery Date
                                  </div>
                                  <div className="invoice-inner-card-text">
                                    {formatDate(
                                      invoiceDetails?.order_reassign_history_response?.find(
                                        (history: any) =>
                                          history?.previous_delivery_date &&
                                          history?.previous_delivery_date !==
                                          history?.delivery_date
                                      )?.previous_delivery_date || ""
                                    )}
                                  </div>
                                </div>
                              </div>

                              <div className="d-flex ps-2">
                                <div className="col-1 text-center hor_line"></div>
                              </div>

                              {invoiceDetails?.order_reassign_history_response?.map(
                                (history: any, index: number) =>
                                  history?.delivery_date &&
                                  history?.previous_delivery_date !==
                                  history?.delivery_date && (
                                    <div key={index}>
                                      <div className="d-flex pt-2">
                                        <div className="col-1 text-center">
                                          <img
                                            src={dashboard_invoice_order_date}
                                            height={"18px"}
                                            alt=""
                                          />
                                        </div>
                                        <div className="col">
                                          <div className="invoice-div-head">
                                            Updated Delivery Date
                                          </div>
                                          <div className="invoice-inner-card-text">
                                            {formatDate(history?.delivery_date)}
                                          </div>
                                        </div>
                                      </div>

                                      <div className="d-flex ps-2">
                                        <div className="col-1 text-center hor_line"></div>
                                      </div>
                                    </div>
                                  )
                              )}
                            </>
                          )}
                      </div>

                      <div className="d-flex ps-2">
                        <div className="col-1 text-center hor_line"></div>
                      </div>
                      <div className="d-flex pt-2">
                        <div className="col-1  text-center">
                          <img
                            src={merchant_dashboard_location_icon}
                            height={"18px"}
                            alt=""
                          />
                        </div>
                        <div className="col">
                          <div
                            className={`col-md-12 invoice-div-head d-flex align-items-center ${invoiceDetails?.latest_modified_field_flags
                              ?.recollection_location ||
                              invoiceDetails?.latest_modified_field_flags
                                ?.recollection_date
                              ? "text-danger"
                              : ""
                              }`}
                          >
                            Recollection Date & Location
                            {(invoiceDetails?.modified_field_flags
                              ?.recollection_location ||
                              invoiceDetails?.modified_field_flags
                                ?.recollection_date) && (
                                <OverlayTrigger
                                  container={refpopup}
                                  trigger={["hover"]}
                                  placement="top"
                                  overlay={popoverHoverFocus}
                                >
                                  <div className="ps-2">
                                    <img
                                      src={manage_my_info_edit_logo}
                                      alt="Edit"
                                      width="18"
                                    />
                                  </div>
                                </OverlayTrigger>
                              )}
                          </div>
                          <div className="invoice-inner-card-text">
                            {formatDate(invoiceDetails?.recollection_date)} |{" "}
                            {invoiceDetails?.recollection_location?.address}
                          </div>
                        </div>
                      </div>
                      {/* <div className="d-flex ps-2">
                        <div className="col-1 text-center hor_line"></div>
                      </div> */}
                      {/* <div className="d-flex pt-2">
                        <div className="col-1  text-center">
                          <img
                            src={dashboard_invoice_payment_done}
                            height={"18px"}
                            alt=""
                          />
                        </div>
                        <div className="col">
                          <div className=" invoice-text-green">
                            {invoiceDetails?.payment_status}
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 pt-5">
              <div className="card invoice-card-inner-mechant">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3 radio_button_text-order">
                      <CustomRadio
                        onChange={() => handleRadioChange("EXTENDED")}
                        checked={selectedOptions === "EXTENDED"}
                        label="EXTENDED"
                      />
                    </div>
                    <div className="col-md-3 radio_button_text-order">
                      <CustomRadio
                        onChange={() => handleRadioChange("RECOLLECTION")}
                        checked={selectedOptions === "RECOLLECTION"}
                        label="RECOLLECTION"
                      />
                    </div>
                    <div className="col-md-3 radio_button_text-order">
                      <CustomRadio
                        onChange={() => handleRadioChange("REPLACEMENT")}
                        checked={selectedOptions === "REPLACEMENT"}
                        label="REPLACEMENT"
                      />
                    </div>
                    <div className="col-md-3 radio_button_text-order">
                      <CustomRadio
                        onChange={() => handleRadioChange("FORCE_PAYMENT")}
                        checked={selectedOptions === "FORCE_PAYMENT"}
                        label="FORCE PAYMENT"
                      />
                    </div>
                  </div>
                </div>
              </div>
              {selectedOptions === "EXTENDED" && (
                <div className="card invoice-card-inner-mechant pt-3  radio_button_text">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-12 pt-3">
                        <label className="invoice-text-yellow">
                          Extended Number of Days
                        </label>
                        <span className="merchanttopstar">*</span>
                        <CustomInput
                          inputName="numberOfDays"
                          inputType="numberOfDays"
                          className="merchant-input-style-create-product"
                          placeholder=""
                          editable={true}
                          //onInputChange={(value: string) => {}}
                          onInputChange={handleNumberOfDaysChange}
                          control={control}
                          // rules={rules.AuthRules.Numbers}
                          rules={{
                            required: "This field is required",
                            pattern: {
                              value: /^[0-9]+$/,
                              message: "Please enter a valid number",
                            },
                          }}
                        />
                      </div>
                      <div className="col-12 pt-3">
                        <label className="invoice-text-yellow form-label">
                          Comments
                        </label>
                        <textarea
                          name="comments"
                          id="comments"
                          rows={5}
                          className="select-invoice-bg-black-textarea"
                          value={comments}
                          onChange={handleCommentsChange}
                        ></textarea>
                      </div>
                    </div>
                    <div className=" text-end">
                      <button
                        className="invoice-approve-btn"
                        disabled={isButtonDisabled()}
                        onClick={handleExtendDay}
                      >
                        {" "}
                        <img
                          src={dashboard_invoice_approve}
                          height={"14px"}
                          alt=""
                        />
                        &nbsp;ACCEPT
                      </button>
                    </div>
                  </div>
                </div>
              )}
              {selectedOptions === "RECOLLECTION" && (
                <div className="card invoice-card-inner-mechant pt-3 radio_button_text">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-12">RECOLLECTION</div>
                      {invoiceDetails?.delivered_by !== "CUSTOMER" && (
                        <div className="col-6 pt-3">
                          <label className="invoice-text-yellow">
                            Delivery Executive Name
                          </label>
                          <CustomInput
                            inputName="deliveryboyName"
                            inputType="deliveryboyName"
                            className="merchant-input-style-create-product"
                            placeholder=""
                            editable={true}
                            //onInputChange={(value: string) => {}}
                            onInputChange={handleDeliveryBoyNameChange}
                            control={control}
                          />
                        </div>
                      )}
                      {invoiceDetails?.delivered_by !== "CUSTOMER" && (
                        <div className="col-6 pt-3">
                          <label className="invoice-text-yellow">
                            Delivery Executive Phone No
                          </label>
                          <div className="inputContainerStyle text-end">
                            <span className="deliveredorders_new_country_codestyle ">
                              +971
                            </span>
                            <CustomInput
                              inputName="phoneNo"
                              inputType="text"
                              className="merchant-input-style-create-product"
                              placeholder=""
                              maxLength={9}
                              editable={true}
                              //onInputChange={(value: string) => {}}
                              onInputChange={handleDeliveryBoyNumberChange}
                              control={control}
                              disableValidation={true}
                            />
                          </div>
                        </div>
                      )}
                      <div className="col-6 pt-3">
                        <label className="invoice-text-yellow">
                          Recollected Fuel
                        </label>
                        <FuelBar>
                          {[...Array(8)].map((_, index) => (
                            <div
                              key={index}
                              className={`fuel-segment ${Number(recollectedFuel) > index ? "active" : ""
                                }`}
                              onClick={() =>
                                handleFuelNumberChange((index + 1).toString())
                              }
                            />
                          ))}
                          <span className="fuel-label">
                            {recollectedFuel ? `${recollectedFuel}/8` : "0/8"}
                          </span>
                        </FuelBar>
                      </div>
                      <div className="col-6 pt-3">
                        <label className="invoice-text-yellow">
                          Recollected Mileage
                        </label>
                        <CustomInput
                          inputName="recollectedMileage"
                          inputType="recollectedMileage"
                          className="merchant-input-style-create-product"
                          placeholder=""
                          editable={true}
                          //onInputChange={(value: string) => {}}
                          onInputChange={handleMileageNumberChange}
                          control={control}
                        />
                      </div>
                      <div className="col-6 pt-3">
                        <label className="invoice-text-yellow">Surcharge</label>

                        {/* <span className="merchantStar">*</span> */}
                        <CustomInput
                          inputName="surcharge"
                          inputType="surcharge"
                          className="merchant-input-style-create-product"
                          placeholder=""
                          editable={true}
                          //onInputChange={(value: string) => {}}
                          onInputChange={handleSurchargeNumberChange}
                          control={control}
                        />
                      </div>
                      <div className="col-6 pt-3">
                        <label className="invoice-text-yellow">
                          Salik Charges
                        </label>

                        {/* <span className="merchantStar">*</span> */}
                        <CustomInput
                          inputName="salicCharge"
                          inputType="salicCharge"
                          className="merchant-input-style-create-product"
                          placeholder=""
                          editable={true}
                          //onInputChange={(value: string) => {}}
                          onInputChange={handleSalicNumberChange}
                          control={control}
                        />
                      </div>
                      <div className="col-6 pt-3">
                        <label className="invoice-text-yellow">
                          Traffic Charges
                        </label>

                        {/* <span className="merchantStar">*</span> */}
                        <CustomInput
                          inputName="trafficCharge"
                          inputType="trafficCharge"
                          className="merchant-input-style-create-product"
                          placeholder=""
                          editable={true}
                          //onInputChange={(value: string) => {}}
                          onInputChange={handleTrafficchargeNumberChange}
                          control={control}
                        />
                      </div>
                      <div className="col-6 pt-3">
                        <label className="invoice-text-yellow">
                          Agreement Number
                        </label>
                        <span className="merchantStar">*</span>
                        <CustomInput
                          inputName="agreementNumber"
                          inputType="agreementNumber"
                          className="merchant-input-style-create-product"
                          placeholder=""
                          editable={true}
                          //onInputChange={(value: string) => {}}
                          onInputChange={handleAgreementNumberChange}
                          control={control}
                        />
                      </div>
                      {/* <div className="col-md-6 pt-3 date-component-rewrite">
                       
                        <input
                          type="datetime-local"
                          id="datetime"
                          value={dateTime}
                          onChange={handleDateTimeChange}
                        />
                      </div> */}
                      <div className="col-md-6 pt-3 date-component-rewrite">
                        <label className="invoice-text-yellow">
                          Recollection Date and Time
                        </label>
                        <span className="merchantStar">*</span>
                        <div className="input-date-container">
                          <input
                            type="datetime-local"
                            id="datetime"
                            value={dateTime}
                            min={minDateTime}
                            onChange={handleDateTimeChange}
                            className="merchant-input-style-create-product"
                            disabled={showRecollectionRequestConfirmationModal}
                          />
                        </div>
                      </div>

                      <div className="col-md-6 pt-3 ">
                        <label className="invoice-text-yellow">
                          {" "}
                          VDR Upload{" "}
                        </label>{" "}
                        <span className="merchantStar">*</span>
                        &nbsp;
                        <button
                          className="btn-custom-upload"
                          onClick={openFileInput}
                        >
                          Browse File
                        </button>
                        <input
                          type="file"
                          ref={fileInputRef}
                          style={{ display: "none" }}
                          multiple
                          onChange={(e) => handleImageUpload(e.target.files)}
                        />
                        {/* Display existing recollected VDR images if available */}
                        {(() => {
                          const existingImages =
                            invoiceDetails?.products?.[0]
                              ?.recollectedCheckListImageUrls ||
                            invoiceDetails?.products?.[0]
                              ?.recollected_check_list_image_urls ||
                            invoiceDetails?.recollectedCheckListImageUrls ||
                            invoiceDetails?.recollected_check_list_image_urls;

                          console.log("Existing VDR Images:", existingImages);

                          return (
                            existingImages &&
                            existingImages.length > 0 &&
                            uploadedImages.length === 0 && (
                              <div className="mt-2">
                                <table className="img-managemycar-table">
                                  {existingImages.map(
                                    (image: string, index: number) => (
                                      <tr key={index}>
                                        <td>
                                          <div>
                                            <img
                                              src={image}
                                              alt={`Existing VDR ${index + 1}`}
                                              className="img-div-custom"
                                              onClick={() =>
                                                onClickVdrDocument(image)
                                              }
                                              style={{ cursor: "pointer" }}
                                            />
                                          </div>
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </table>
                              </div>
                            )
                          );
                        })()}
                        {/* Display newly uploaded images */}
                        {uploadedImages.length > 0 && (
                          <table className="img-managemycar-table">
                            {uploadedImages.map((image, index) => (
                              <tr key={index}>
                                <td>
                                  <div>
                                    <img
                                      src={image}
                                      alt={`Uploaded Image ${index + 1}`}
                                      className="img-div-custom"
                                    />
                                  </div>
                                </td>
                                <td>
                                  <span
                                    className="text-danger cursor-pointer ms-2"
                                    onClick={() =>
                                      handleUploadDeleteImage(index)
                                    }
                                  >
                                    <Trash />
                                  </span>
                                </td>
                              </tr>
                            ))}
                          </table>
                        )}
                      </div>

                      <div className="col-12 pt-3">
                        <label className="invoice-text-yellow form-label">
                          Comments
                        </label>
                        <textarea
                          name="comments"
                          id="comments"
                          rows={5}
                          className="select-invoice-bg-black-textarea"
                          value={comments}
                          onChange={handleCommentsChange}
                        ></textarea>
                      </div>
                    </div>
                    <div className="text-end ">
                      <button
                        disabled={isButtonDisabled()}
                        onClick={handleSubmit}
                        className="invoice-approve-btn"
                      >
                        {" "}
                        <img
                          src={dashboard_invoice_approve}
                          height={"14px"}
                          alt=""
                        />
                        &nbsp;ACCEPT
                      </button>
                    </div>
                  </div>
                </div>
              )}
              {selectedOptions === "REPLACEMENT" && (
                <div className="card invoice-card-inner-mechant pt-3  radio_button_text">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-12 pt-3">
                        <label className="invoice-text-yellow">
                          Replacement VDR/Rental Upload{" "}
                          <span className="merchantStar">*</span>
                        </label>
                        <button
                          className="btn-custom-upload ms-2"
                          onClick={openReplacementFileInput}
                          disabled={replacementUploadedImages.length >= 2}
                        >
                          Browse File
                        </button>
                        <input
                          type="file"
                          ref={replacementFileInputRef}
                          style={{ display: "none" }}
                          multiple
                          onChange={(e) =>
                            handleReplacementImageUpload(e.target.files)
                          }
                        />
                        <table className="img-managemycar-table">
                          {replacementUploadedImages.map((image, index) => (
                            <tr key={index}>
                              <td>
                                <div>
                                  <img
                                    src={image}
                                    alt={`Replacement VDR ${index + 1}`}
                                    style={{
                                      width: "100px",
                                      height: "100px",
                                      objectFit: "cover",
                                    }}
                                    onClick={() => {
                                      setImageSource(image);
                                      setShowImagePopupModal(true);
                                    }}
                                  />
                                </div>
                              </td>
                              <td>
                                <Trash
                                  className="delete-icon"
                                  onClick={() =>
                                    handleReplacementUploadDeleteImage(index)
                                  }
                                />
                              </td>
                            </tr>
                          ))}
                        </table>
                        <div className="text-end ">
                          <button
                            disabled={isButtonDisabled()}
                            onClick={handleSubmit}
                            className="invoice-approve-btn"
                          >
                            {" "}
                            <img
                              src={dashboard_invoice_approve}
                              height={"14px"}
                              alt=""
                            />
                            &nbsp;Upload
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {selectedOptions === "FORCE_PAYMENT" && (
                <div className="card invoice-card-inner-mechant pt-3 radio_button_text">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-12">FORCE PAYMENT</div>
                      <div className="col-12 pt-3">
                        <label className="invoice-text-yellow">
                          Payment Amount
                        </label>
                        <span className="merchantStar">*</span>
                        <CustomInput
                          inputName="forceAmount"
                          inputType="text"
                          className="merchant-input-style-create-product"
                          placeholder="Enter amount"
                          editable={true}
                          onInputChange={handleForceAmountChange}
                          control={control}
                          rules={{
                            required: "Amount is required",
                            pattern: {
                              value: /^[0-9]+(\.[0-9]{1,2})?$/,
                              message: "Please enter a valid amount",
                            },
                          }}
                        />
                      </div>
                    </div>
                    <div className="text-end mt-3">
                      <button
                        disabled={!forceAmount || forcePaymentMutation.isPending}
                        onClick={() => forcePaymentMutation.mutate()}
                        className="invoice-approve-btn"
                      >
                        {forcePaymentMutation.isPending ? "PROCESSING..." : "PROCESS PAYMENT"}
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <ErrorModal
        isOpen={showErrorModal}
        onClose={() => setShowErrorModal(false)}
        message="Oops! Something went wrong"
      />

      <ImagePopupModal
        isOpen={showImagePopupModal}
        //  onClose={onCloseImagePopupModal}
        src={imageSource}
        onClose={() => setShowImagePopupModal(false)}
        message={""}
      />

      <ConfirmationModal
        isOpen={showAcceptConfirmationModal}
        onClose={() => setShowAcceptConfirmationModal(false)}
        onConfirm={() => {
          handleApproval.mutate();
          setShowAcceptConfirmationModal(false);
        }}
        message={acceptConfirmationMessage}
      />

      <ConfirmationModal
        isOpen={showExtendConfirmationModal}
        onClose={() => setShowExtendConfirmationModal(false)}
        onConfirm={() => {
          handleExtend.mutate();
          setShowExtendConfirmationModal(false);
        }}
        message={extendConfirmationMessage}
      />
      <ConfirmationModal
        isOpen={showRecollectionRequestConfirmationModal}
        onClose={() => {
          setShowRecollectionRequestConfirmationModal(false);
          // Clear VDR images when modal is closed
          setRecollectionVdrImages([]);
          setRecollectionVdrUploadedImages([]);
          if (recollectionVdrFileInputRef.current) {
            recollectionVdrFileInputRef.current.value = "";
          }
        }}
        onConfirm={() => {
          handleRecollectionRequest.mutate();
          setShowRecollectionRequestConfirmationModal(false);
        }}
        message={recollectionRequestConfirmationMessage}
      >
        <div className="mt-3">
          <label className="invoice-text-yellow">Upload VDR</label>
          <button
            className="btn-custom-upload ms-2"
            onClick={openRecollectionVdrFileInput}
          >
            Browse File
          </button>
          <input
            type="file"
            ref={recollectionVdrFileInputRef}
            style={{ display: "none" }}
            multiple
            onChange={(e) => handleRecollectionVdrUpload(e.target.files)}
          />
          {recollectionVdrUploadedImages.length > 0 && (
            <table className="img-managemycar-table mt-2">
              {recollectionVdrUploadedImages.map((image, index) => (
                <tr key={index}>
                  <td>
                    <div>
                      <img
                        src={image}
                        alt={`Recollection VDR ${index + 1}`}
                        style={{
                          width: "100px",
                          height: "100px",
                          objectFit: "cover",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setImageSource(image);
                          setShowImagePopupModal(true);
                        }}
                      />
                    </div>
                  </td>
                  <td>
                    <Trash
                      className="delete-icon"
                      onClick={() => handleRecollectionVdrDeleteImage(index)}
                    />
                  </td>
                </tr>
              ))}
            </table>
          )}
        </div>
      </ConfirmationModal>
    </div>
  );
};

export default DeliveredorderDetails;
